import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';

const styles = () => ({
  fabButton: {
    color: '#fff',
    fontSize: 20,
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
});

class PupilFab extends React.Component {
  render() {
    const {
      classes,
      onPupilClick,
      initial,
      backgroundColor,
      backgroundColorHover,
    } = this.props;
    return (
      <div className="pupil-fab">
        <Fab
          className={classes.fabButton}
          onClick={onPupilClick}
          style={{
            backgroundColor,
            '&:hover': {
              backgroundColor: backgroundColorHover,
            },
          }}
        >
          {initial}
        </Fab>
      </div>
    );
  }
}

export default withStyles(styles)(PupilFab);
